import { produce } from "immer";

import {
  ProductsBrandsActionsTypes,
  ProductsBrandsReducerActions,
  ProductsBrandsState
} from "../types/ProductsBrands.reducer.types";

const INITIAL_STATE: ProductsBrandsState = {
  list: undefined,
  isLoadingList: false,
  message: undefined
};

export default function reducer(
  state = INITIAL_STATE,
  action: ProductsBrandsReducerActions
): ProductsBrandsState {
  return produce(state, draft => {
    switch (action.type) {
      case ProductsBrandsActionsTypes.CREATE_REQUEST: {
        draft.message = undefined;
        break;
      }

      case ProductsBrandsActionsTypes.CREATE_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case ProductsBrandsActionsTypes.CREATE_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case ProductsBrandsActionsTypes.DISMISS_MESSAGE: {
        draft.message = undefined;
        break;
      }

      case ProductsBrandsActionsTypes.EDIT_REQUEST: {
        draft.message = undefined;
        break;
      }

      case ProductsBrandsActionsTypes.EDIT_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case ProductsBrandsActionsTypes.EDIT_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case ProductsBrandsActionsTypes.LIST_REQUEST: {
        draft.isLoadingList = true;
        draft.list = undefined;
        break;
      }

      case ProductsBrandsActionsTypes.LIST_FAIL: {
        draft.isLoadingList = false;
        draft.list = undefined;
        break;
      }

      case ProductsBrandsActionsTypes.LIST_SUCCESS: {
        draft.isLoadingList = false;
        draft.list = action.payload.list;
        break;
      }
      default:
    }
  });
}
